module.exports = __webpack_public_path__ + "static/media/backArrow.edf97fc0.svg";